<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'source-user',
  },
})

import { getProjectId } from "@/utils/cdms"
import { VDataTable } from 'vuetify/labs/VDataTable'

const { t } = useI18n()
const page = ref(1)
const itemsPerPage = ref(10)
const selected = ref([])
const projectLocked = ref(await isLockedProject())
const users = ref([])
const search = ref('')

const headers =  ref([
  {
    title: t('Email'),
    key: 'email',
  },
  { title: t('User Name'),  key: 'name' },
  { title: t('Start Date'),  key: 'start_date' },
  { title: t('End Date'),  key: 'end_date' },
  { title: t('Status'),  key: 'status' },
  { title: t('Site'),  key: 'site_name' },
  { title: t('Role'),  key: 'role' },
  { title: t('Edit'),  key: 'actions', sortable: false, width: "120px" },
])

const loadItems = async() => {

  const {
    data: usersData,
    execute: fetchUsers,
  } = await useApi(createUrl('/sources/users', {
    query: {
      projectId: getProjectId(),
    },
  }))

  users.value = usersData.value.forEach(element => {
    if(element.status == 'Expired') {
      element.selectable = false
      if(selected.value.indexOf(element.id) == -1) selected.value.push(element.id)
    }
  })

  users.value = usersData.value
}

const filterItems = [
  { value: "email", title: "이메일" },
  { value: "name", title: "사용자명" },
]

const filterItem = ref('name')

const filterText = (value, query, item) => {
  return value != null &&  query != null &&
        typeof value === 'string' &&
        item.columns[filterItem.value].toLowerCase().indexOf(query.toLowerCase()) !== -1
}


const expireItem = async ids => {
  const result = await $api(`/sources/users`, { method: 'DELETE',
    body: { ids } })

  selected.value = []
  loadItems()
}

const expireItems = () => {
  if(selected.value.length > 0) expireItem(selected.value)
}
</script>

<template>
  <h3 class="text-lg font-semibold mb-8">
    사용자 등록
  </h3>
  <VCard>
    <VCardText>
      <div class="d-flex justify-space-between flex-wrap gap-y-4">
        <div>
          <VBtn
            size="small"
            color="secondary"
            :disabled="projectLocked"
            @click="expireItems"
          >
            {{ $t('Expire') }}
          </VBtn>
        </div>
        <div class="d-flex flex-row align-center flex-wrap">
          <AppSelect
            v-model="filterItem"
            :items="filterItems"
            style="inline-size:150px;"
          />
          <AppTextField
            v-model="search"
            class="pe-4"
            style="inline-size: 200px;"
            :placeholder="$t('Search') + '...'"
            density="compact"
          />
          <VBtn
            prepend-icon="tabler-plus"
            color="success"
            :disabled="projectLocked"
            @click="$router.push('/sources/users/create')"
          >
            {{ $t('Add User') }}
          </VBtn>
        </div>
      </div>
    </VCardText>
    <VCardText>
      <VDataTable
        v-model:items-per-page="itemsPerPage"
        v-model:page="page"
        v-model="selected"
        :headers="headers"
        :items="users"
        :search="search"
        density="compact"
        :custom-filter="filterText"
        show-select
        class="custom-table"
        item-selectable="selectable"
        @update:options="loadItems"
      >
        <!--
          <template #item.select="{ item }">
          <VCheckbox
          v-model="isActive"
          :disabled="item.status!='Active'"
          :value="item.id"
          color="secondary"
          />
          </template>
        -->


        <template #item.name="{ item }">
          <div :class="{'deleted' : item.status!='Active'}">
            {{ item.name }}
          </div>
        </template>

        <template #item.actions="{ item }">
          <div class="d-flex gap-1">
            <IconBtn
              :disabled="projectLocked"
              @click="$router.push({ name: 'sources-users-edit-id', params: { id:item.id} })"
            >
              <VIcon icon="tabler-edit" />
              <VTooltip
                activator="parent"
                location="top"
              >
                수정
              </VTooltip>
            </IconBtn>
            <!--
              <IconBtn @click="$router.push({ name: 'users-edit-id', params: {id:item.id} })">
              <VIcon icon="tabler-edit" />
              </IconBtn>
            -->
            <IconBtn
              v-if="item.status=='Active'"
              :disabled="projectLocked"
              @click="expireItem([item.id])"
            >
              <VIcon
                icon="tabler-clock-cancel"
                color="error"
              />
              <VTooltip
                activator="parent"
                location="top"
              >
                {{ $t('Expire') }}
              </VTooltip>
            </IconBtn>
          </div>
        </template>
      <!--
        <template #bottom>
        <div class="d-flex align-center justify-sm-space-between justify-center flex-wrap gap-3 pa-5 pt-3">
        <p class="text-sm text-disabled mb-0">
        {{ paginationMeta({ page, itemsPerPage }, users.length) }}
        </p>
        <VSpacer />
        <div class="d-flex flex-row gap-4 align-center flex-wrap">
        <span class="text-sm font-weight-medium">Items per page:</span>
        <AppSelect
        v-model="itemsPerPage"
        density="compact"
        :items="[5, 10, 20, 50, 100]"
        />
        </div>
        <VPagination
        v-model="page"
        :total-visible="$vuetify.display.smAndDown ? 3 : 5"
        :length="Math.ceil(users.length / itemsPerPage)"
        />
        </div>
        </template>
      -->
      </VDataTable>
    </VCardText>
  </VCard>
</template>

<style lang="scss" scoped>
.deleted {
  text-decoration: line-through;
}


:deep(.custom-table .v-table__wrapper table) {
  th {
    background: #F3F5F8 !important;  /* 밝은 회색 배경 */
    border-block-end: 1px solid #eee;
    color: #909090 !important;       /* 연한 회색 텍스트 */
    font-size: 13px;
    font-weight: 500;
    padding-block: 10px;
    padding-inline: 12px;
  }

  td {
    border-block-end: 1px solid #E8EBEE;
    color: #444;
    font-size: 14px;
    padding-block: 8px;
    padding-inline: 12px;
  }

  tr:hover td {
    background-color: #f9f9fc; /* hover 시 은은한 하이라이트 */
  }
}

:deep(.custom-table .v-badge__badge) {
  border-radius: unset;
  font-size: 8px;
  margin-inline-start: 5px;
  min-inline-size: 10px;
}

:deep(.v-card-item) {
  padding: 12px;
}
</style>
